import React from 'react';
import PropTypes from 'prop-types';
import useTranslation from 'next-translate/useTranslation';

// PropTypes
import { jobPropTypes } from '../../../../../proptypes/jobProptypes';

// Icons
import { Clock } from '../../../../icons';

// Styles
import styles from '../jobBulletpoints.module.scss';

const JobWorkload = ({ job, textColor }) => {
  const { t } = useTranslation('common');

  const calculatePercentage = () => {
    let percentage = '';

    if (job.extra_info) {
      if (job.extra_info?.employment_type === 'fulltime') {
        percentage = '100%';
      } else if (
        job.extra_info?.employment_type_min ===
        job.extra_info?.employment_type_max
      ) {
        percentage = job.extra_info?.employment_type_max;
      } else {
        percentage = `${job.extra_info?.employment_type_min} - ${job.extra_info?.employment_type_max}`;
      }
    }
    return percentage;
  };

  const calculateWorkloadType = (percentage) => {
    if (!percentage) return 'part_time';

    if (percentage === '100%') return 'full_time';

    const [min, max] = percentage.split(' - ');

    if (min && max && parseInt(min, 10) < 100 && parseInt(max, 10) === 100) {
      return 'full_or_part_time';
    }

    return 'part_time';
  };

  const percentage = calculatePercentage();
  const workloadType = calculateWorkloadType(percentage);

  return (
    <div className={styles.container}>
      <span className={styles.content}>
        <span className={styles.iconWrapper}>
          <Clock fill={textColor} className={styles.icon} />
        </span>
        <span className={styles.text} data-testid="workload">
          {t(`description_page.main_section.workload.${workloadType}`)}{' '}
          {percentage}
        </span>
      </span>
    </div>
  );
};

JobWorkload.propTypes = {
  job: PropTypes.shape(jobPropTypes).isRequired,
  textColor: PropTypes.string.isRequired,
};

export default JobWorkload;
